import { BrowserRouter, Routes, Route } from "react-router-dom";


import HomePage from "./pages/HomePage";
import AncientScrolls from "./pages/AncientScrolls";
import WatchTower from "./pages/WatchTower";
import CovenantPartnership from "./pages/CovenantPartnership";
import IProphecy from "./pages/IProphecy";
import ContactPage from "./pages/ContactPage";
import VoiceOfGlory from "./pages/VoiceOfGlory";
import ITestify from "./pages/ITestify";
import Books from "./pages/Books";
import About from "./pages/About";
import LiveTv from "./pages/LiveTv";
import GivePage from "./pages/GivePage";
import ThemeIcons from "./components/ThemeIcons";
import ScrollToHash from "./components/ScrollToHash";

const App = () => {
    return (
        <BrowserRouter>
            {/* Theme selector persists across all pages */}
            <ThemeIcons />
              <ScrollToHash />

            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/watchtower" element={<WatchTower />} />
                <Route path="/ancientscrolls" element={<AncientScrolls />} />
                <Route path="/about" element={<About />} />
                <Route path="/books" element={<Books />} />
                <Route path="/covenantpartnership" element={<CovenantPartnership />} />
                <Route path="/iprophecy" element={<IProphecy />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/voiceofglory" element={<VoiceOfGlory />} />
                <Route path="/itestify" element={<ITestify />} />
                <Route path="/live-tv" element={<LiveTv />} />
                <Route path="/give" element={<GivePage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
